const name = 'circle-c';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path d="M31.657 55.5c-2.375 0-4.377-.373-6.007-1.119-1.63-.745-2.955-1.767-3.977-3.065-1.022-1.298-1.754-2.831-2.196-4.599-.442-1.767-.663-3.673-.663-5.717 0-1.989.221-3.867.663-5.634.442-1.768 1.174-3.315 2.196-4.64 1.022-1.326 2.347-2.362 3.977-3.107 1.63-.746 3.632-1.119 6.007-1.119 3.204 0 6.38.718 9.529 2.154l-1.077 4.309c-2.928-1.215-5.552-1.823-7.872-1.823-2.817 0-4.82.898-6.007 2.693-1.188 1.795-1.781 4.184-1.781 7.167 0 2.983.593 5.372 1.781 7.167s3.19 2.693 6.007 2.693c2.265 0 4.889-.58 7.872-1.74l1.077 4.226c-3.149 1.436-6.325 2.154-9.529 2.154z" fill="#FFF"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'C',
};

export default icon;
